/**
 * Pick currency offer matching billing period (months).
 * @param {{ currency_offers?: Array, period: number }} params
 * @returns {object|undefined}
 */
const getCurrencyOfferByPeriod = ({ currency_offers, period }) => {
  if (!Array.isArray(currency_offers)) {
    return;
  }

  const hasSomeCurrencyOffers = currency_offers.length;

  const currencyOffer = currency_offers.find(
    ({ periods }) => periods === period
  );

  if (currencyOffer) {
    return currencyOffer;
  }

  // If we have any currency offers, we can't assume that the offer is for 0.
  if (hasSomeCurrencyOffers) {
    return;
  }

  return {
    period_text: null,
    offer_amount: 0,
    order_monthly_amount: 0,
    monthly_amount: 0,
    periods: null
  };
};

export default getCurrencyOfferByPeriod;
